module.exports = __webpack_public_path__ + "static/media/yewu-cj3.d1751022.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/pageBrain/yewu-cj3.png
// module id = 596
// module chunks = 0